import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const r = i((e, m) => /* @__PURE__ */ a.jsx(
  o,
  {
    ref: m,
    ...e,
    image: (l) => /* @__PURE__ */ a.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: [
          /* @__PURE__ */ a.jsx("mask", { id: "path-1-inside-1_3327_71948", fill: "#fff", children: /* @__PURE__ */ a.jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m0 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-4 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ a.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M20 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m0 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-4 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ a.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M16 10a6 6 0 0 0 6-6h-4a2 2 0 0 1-2 2zm-6-6a6 6 0 0 0 6 6V6a2 2 0 0 1-2-2zm6-6a6 6 0 0 0-6 6h4a2 2 0 0 1 2-2zm6 6a6 6 0 0 0-6-6v4a2 2 0 0 1 2 2zm-6 18a6 6 0 0 0 6-6h-4a2 2 0 0 1-2 2zm-6-6a6 6 0 0 0 6 6v-4a2 2 0 0 1-2-2zm6-6a6 6 0 0 0-6 6h4a2 2 0 0 1 2-2zm6 6a6 6 0 0 0-6-6v4a2 2 0 0 1 2 2zm-4 12a2 2 0 0 1-2 2v4a6 6 0 0 0 6-6zm-2-2a2 2 0 0 1 2 2h4a6 6 0 0 0-6-6zm-2 2a2 2 0 0 1 2-2v-4a6 6 0 0 0-6 6zm2 2a2 2 0 0 1-2-2h-4a6 6 0 0 0 6 6z",
              mask: "url(#path-1-inside-1_3327_71948)"
            }
          )
        ]
      }
    )
  }
));
r.displayName = "OtherIcon";
export {
  r as OtherIcon,
  r as default
};
//# sourceMappingURL=index.js.map
